export class ManualApplicationPayment {
    constructor(
    public Client_ClientId: number,
    public RawDataImport_ShardClaimIdentifier: number,
    public PaymentDetail_Remittance_RemittanceId: number,
    public PaymentDetail_Remittance_RemittanceAmount: number) {}
}



// WEBPACK FOOTER //
// ./src/app/models/manualApplicationPayment.model.ts